import React, { useEffect } from 'react';
import { _$ } from '../controllers/dom';

const Loading = (props) => {
    const { theme } = props;

    const animate = (n) => {
        if (!_$('progressBar')) return;
        if (n >= 100) {
            n = 0;
        }
        n++;
        _$('progressBar').style.width = `${n}%`;
        setTimeout(() => animate(n), 100);
    };

    useEffect(() => {
        animate(0);
    });

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'} mt-5`}>
            <div className="progress">
                <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    id="progressBar"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                </div>
            </div>
        </div>
    );
};

export default Loading;
